module.exports = __webpack_public_path__ + "static/media/logo.84972a17.svg";